import { render, staticRenderFns } from "./TgLiveDetailHeader.vue?vue&type=template&id=0244cbfe&"
import script from "./TgLiveDetailHeader.vue?vue&type=script&lang=js&"
export * from "./TgLiveDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports